import { DatabaseWrapper } from '../../../shared/databases/database.wrapper';
import { Database } from '../../../shared/databases/database';
import { DatabaseEnum } from 'src/app/shared/databases/databases.enum';
import { RepConnWrapper } from '../../repconn/repconn.wrapper';

export class Azure_blob_storageWrapper extends DatabaseWrapper {

    constructor(database: Database) {
        super(database);

        this.dbTyp_Id = DatabaseEnum.azure_blob_storage.ID;
        this.name = DatabaseEnum.azure_blob_storage.NAME;
        this.code = DatabaseEnum.azure_blob_storage.CODE;
        this.showDatabaseTab=false;
        this.showDataDescription = false;
        this.equivalentTag = 'bsid';
    }

    validateRepConn(repConnWrapper: RepConnWrapper): void {
        if (repConnWrapper.repConn.conn.dbAliasNm == '') {
            repConnWrapper.inValid_Cds.push('STORAGE_ACCNM');
        }

        if (repConnWrapper.repConn.conn.accessToken == '') {
            repConnWrapper.inValid_Cds.push('STORAGE_ACCKEY');
        }

        if (repConnWrapper.repConn.conn.bucketNm == '') {
            repConnWrapper.inValid_Cds.push('CONTAINER');
        }

        if (repConnWrapper.repConn.conn.flagent_Id == -1) {
            repConnWrapper.inValid_Cds.push('ESM00202');
        }
    }


}
